import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FuncionService } from '../../servicios/funcion.service';
import { environment } from '../../../environments/environment.prod';

@Component({
  selector: 'app-contacto-form',
  templateUrl: './contacto-form.component.html',
  styleUrls: ['./contacto-form.component.css']
})
export class ContactoFormComponent implements OnInit {

	listaSucursales:any[] = [];
	contacto: any = {
  		nombre:"",
  		telefono:"",
  		correo:"",
  		descripcion:""
  	}

  	constructor( 
      private newFuncionService:FuncionService,
      private newTitle: Title
     ){ }

  	ngOnInit(): void {
      this.newTitle.setTitle("Contacto Pawerful");
  		this.fnInitForm();
  		this.newFuncionService.listaSucursales().subscribe( (listaSucursales)=>{
  			if( listaSucursales.length > 0 ){
          this.listaSucursales = listaSucursales;
  			}
  		})
  	}

  	fnInitForm(){
  		this.contacto = {
	  		nombre:"",
	  		telefono:"",
	  		correo:"",
	  		descripcion:""
	  	}
  	}

  	fnValidarFormulario(){
  		if( this.contacto.nombre === "" ){
  			this.newFuncionService.setNewAlerta( environment.alerta.contacto.nombre );
  		}else if( this.contacto.telefono === "" ){
  			this.newFuncionService.setNewAlerta( environment.alerta.contacto.telefono.vacio );
  		}else if( this.contacto.correo === "" ){
  			this.newFuncionService.setNewAlerta( environment.alerta.contacto.correo.vacio );
  		}else if( !environment.validacion.correo.test(this.contacto.correo) ){
  			this.newFuncionService.setNewAlerta( environment.alerta.contacto.correo.formato );
  		}else if( this.contacto.descripcion === "" ){
  			this.newFuncionService.setNewAlerta( environment.alerta.contacto.descripcion );
  		}else{
        this.newFuncionService.setNewMensaje("Enviando tus datos de contacto...");
  			this.newFuncionService.fnEnvioContacto({contacto:this.contacto}).subscribe( (newItem:any)=>{
  				this.newFuncionService.setNewMensaje(null);
  				if( newItem.success ){
  					this.fnInitForm();
  					this.newFuncionService.setNewAlerta( environment.alerta.contacto.success );
  				}else{
  					this.newFuncionService.setNewAlerta( environment.alerta.contacto.fail );
  				}
  			});
  		}
  	}

}
